
import { useState, useEffect } from 'react';

export interface VipStore {
  storeId: string;
  badge: string;
  badgeColor: string;
  highlight: boolean;
}

interface VipSettings {
  stores: VipStore[];
}

export function useVipBadges() {
  const [vipStores, setVipStores] = useState<VipStore[]>([]);

  useEffect(() => {
    const raw = localStorage.getItem('vip_badge_settings');
    if (raw) {
      try {
        const settings: VipSettings = JSON.parse(raw);
        setVipStores(settings.stores || []);
      } catch {
        setVipStores([]);
      }
    }
  }, []);

  const getVipBadge = (storeId: string): VipStore | null => {
    return vipStores.find(v => v.storeId === storeId) || null;
  };

  const isHighlighted = (storeId: string): boolean => {
    const vip = vipStores.find(v => v.storeId === storeId);
    return vip?.highlight || false;
  };

  return { vipStores, getVipBadge, isHighlighted };
}
